import styled, { Color, Breakpoint, Spacing } from '@nfinite/react-hubstairs/styled'

import CloseComponent from 'components/Commons/Close'

export const Container = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background-color: ${Color.get('background')};
  z-index: 9999;
`

export const Close = styled(CloseComponent)`
  position: sticky;
  right: 20px;
  top: 20px;
  z-index: 9999;
  width: fit-content;
  ${Spacing.generateMargin({ top: 'm', left: 'auto' })}

  ${Breakpoint.greaterThanMobile()} {
    position: fixed;
    width: auto;
    ${Spacing.generateMargin({ top: '0', left: '0' })}
  }
`
